import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MinimapService {

  private readonly visibility = signal(false);
  public readonly isVisible = this.visibility.asReadonly();

  public setVisibility(show: boolean): void {
    this.visibility.set(show);
  }
}
